import React from 'react';
import PropTypes from 'prop-types';
import { productShape } from 'constants/propTypes';
import { FormattedMessage } from 'react-intl';
import { ChevronDown, ChevronUp } from 'react-feather';
import Button from 'components/ui/Button';

const ShowFareConditions = ({ showFareConditions, handleOnClick, uniqueProductFamilies = [] }) => {
  const familyGroupNames = uniqueProductFamilies.map((e) => e.familyGroupName).join(' - ');
  return (
    <Button data-cy="toggle-fare-conditions" margin="4px 0" onClick={handleOnClick}>
      {showFareConditions ? (
        <>
          <ChevronUp height={'1.25em'} />
          <FormattedMessage id="journeySegment.hideAftersales" />
          <> - {familyGroupNames}</>
        </>
      ) : (
        <>
          <ChevronDown height={'1.25em'} />
          <FormattedMessage id="journeySegment.showAftersales" />
          <> - {familyGroupNames}</>
        </>
      )}
    </Button>
  );
};

ShowFareConditions.propTypes = {
  showFareConditions: PropTypes.bool,
  handleOnClick: PropTypes.func,
  uniqueProductFamilies: PropTypes.array,
  products: productShape
};

export default ShowFareConditions;
